import React from 'react';
import { Modal } from 'react-bootstrap';

export default function ModalAtivarAviso(props) {
  const { show, onHide, onConfirm, revendaInativa, redeInativa } = props;

  const getMensagem = () => {
    if (revendaInativa && redeInativa) {
      return 'Ao ativar este vendedor, a revenda e a rede também serão ativadas automaticamente.';
    } else if (revendaInativa) {
      return 'Ao ativar este vendedor, a revenda também será ativada automaticamente.';
    } else if (redeInativa) {
      return 'Ao ativar este vendedor, a rede também será ativada automaticamente.';
    }
    return '';
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>Atenção</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0">
        <div className="d-flex justify-content-center align-items-center text-center w-100 p-4">
          <span>{getMensagem()}</span>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-center align-items-center w-100">
          <button
            type="button"
            className="btn btn-success m-1"
            onClick={onConfirm}
          >
            CONFIRMAR
          </button>
          <button
            type="button"
            className="btn btn-danger m-1"
            onClick={onHide}
          >
            CANCELAR
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}


